import {
  AppWindow,
  BarChart3,
  Boxes,
  Briefcase,
  CalendarClock,
  ClipboardList,
  DollarSign,
  Package,
  ShoppingCart,
  Truck,
  Users,
  Wrench,
  type LucideIcon,
} from "lucide-react";
import { cx } from "./ui";

/** Restrained, curated icon set for registered applications. */
const ICONS: Record<string, LucideIcon> = {
  "app-window": AppWindow,
  sales: DollarSign,
  commissions: DollarSign,
  "bar-chart": BarChart3,
  analytics: BarChart3,
  inventory: Boxes,
  package: Package,
  service: Wrench,
  wrench: Wrench,
  rental: CalendarClock,
  calendar: CalendarClock,
  people: Users,
  users: Users,
  orders: ShoppingCart,
  delivery: Truck,
  tasks: ClipboardList,
  briefcase: Briefcase,
};

export function AppIcon({ icon, className, size = "md" }: { icon: string; className?: string; size?: "sm" | "md" | "lg" }) {
  const box = { sm: "size-8 rounded-lg", md: "size-11 rounded-xl", lg: "size-12 rounded-xl" }[size];
  const glyph = { sm: "size-4", md: "size-5", lg: "size-6" }[size];
  if (/^https:\/\//.test(icon)) {
    return <img src={icon} alt="" className={cx(box, "object-cover", className)} />;
  }
  const Icon = ICONS[icon] ?? AppWindow;
  return (
    <span
      className={cx(
        box,
        "inline-flex shrink-0 items-center justify-center bg-gradient-to-br from-navy-2 to-navy text-white ring-1 ring-white/10 dark:from-accent-soft dark:to-surface-3 dark:text-accent",
        className,
      )}
    >
      <Icon className={glyph} aria-hidden />
    </span>
  );
}
